import {GetRequest} from "../../../components/request";
import Notify from "../../../components/Baran/noty/notify";

export const getUI = () => dispatch => {
    let token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
    GetRequest('/api/ui',
        {
            'Authorization': token
        }, true).then((response) => {
        let result = response.data;
        if (result.ok) {
            result = result.data;
            localStorage.setItem('menu', JSON.stringify(result.menu))
            dispatch({
                type: "UI",
                payload: result
            });
        }
    }).catch(function (error) {
        Notify('error', 'topRight', "خطایی رخ داده است");
    });
}
